import React, { useEffect, useState, useCallback } from 'react';
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Table,
  Pagination,
  Modal
} from 'antd';
// import {
//     BrowserRouter as Router,
//     Route
//   } from "react-router-dom";
import { usePageData } from '../../../hooks/usePage';
import { IPageData } from '../../../interfaces/page';
import generalesProvider from '../../../services/generalesProvider';
import { SearchOutlined } from '@ant-design/icons';
import gestionDocumentosProvider from '../../../services/gestiondocumentos';
import { useHistory } from 'react-router-dom';
const { Option } = Select;
const pageData: IPageData = {
  fulFilled: true,
  breadcrumbs: [
    {
      title: 'Administración de Documentos',
      route: 'administracion-regdocumentos'
    },
    {
      title: 'Bandeja de Documentos'
    }
  ]
};
const pageSize = 10;
const PaginacionPersonalizada = ({ total, onChange, current }) => {
  return (
    <Pagination
      onChange={onChange}
      simple={true}
      total={total}
      current={current}
      pageSize={pageSize}
    />
  );
};
interface Filtro {
  IdEstado: Number;
  Cip: string;
}

const GestionDocumentos = () => {
  usePageData(pageData);
  const [listEstado, setListEstado] = useState<any>([]);
  const [filtro, setfiltro] = useState<Filtro>({
    IdEstado: 1,
    Cip: ''
  });
  const [data, setData] = useState({ data: [], totalRecords: 0 });
  const [current, setCurrent] = useState(1);
  const [listAprobadores, setListAprobadores] = useState<any>([]);
  const [formModalSolAprobador] = Form.useForm();
  const [isModalSolAprobadorVisible, setisModalSolAprobadorVisible] = useState(false);
  const [formFile] = Form.useForm();
  let history = useHistory();
  const columns = [
    {
      title: 'Nombre Documento',
      dataIndex: 'nombredocumento',
      key: 'nombredocumento',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Versión Documento',
      dataIndex: 'versiondocumento',
      key: 'versiondocumento',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Proceso',
      dataIndex: 'proceso',
      key: 'proceso',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Dirección',
      dataIndex: 'direccion',
      key: 'direccion',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Area',
      dataIndex: 'area',
      key: 'area',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },

    {
      title: 'Responsable',
      dataIndex: 'responsable',
      key: 'responsable',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Ubicación',
      dataIndex: 'ubicacion',
      key: 'ubicacion',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Estado',
      dataIndex: 'descripcionEstado',
      key: 'descripcionEstado',
      render: (text) => <a>{text}</a>
      // width: '75%'
    },
    {
      title: 'Acción',
      key: 'action',
      render: (text, record) => {
        if (text.estado == 1) {
          /*Pendiente */
          return (
            <Space size='middle'>
              <Button size='small' type='primary' onClick={(e) => btnAprobacionFinal(text.id)}>
                Apro. Final
              </Button>
              <Button size='small' type='primary' onClick={(e) => btnSolicitarAprobacion(text.id)}>
                Sol. Apro. De
              </Button>
              <Button size='small' type='primary' onClick={(e) => btnEditarDocumento(text)}>
                Editar
              </Button>
            </Space>
          );
        } else if (text.estado == 2) {
          /*Aprobado*/
          return (
            <Space size='middle'>
              <Button size='small' type='primary' onClick={(e) => btnEditarDocumento(text)}>
                Ver Detalle
              </Button>
            </Space>
          );
        }
      },
      align: 'center' as 'center'
    }
  ];
  const formItemLayout = {
    labelCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 4
      }
    },
    wrapperCol: {
      xs: {
        span: 24
      },
      sm: {
        span: 20
      }
    }
  };
  const btnAprobacionFinal = async (id) => {
    const res: any = await gestionDocumentosProvider.AprobacionFinal({ id: id });
    if (res.succeeded) {
      message.success(res.message);
      listarArchivos();
    } else message.warning(res.message);
  };
  const btnSolicitarAprobacion = (id) => {
    obtenerListaValor();
    formModalSolAprobador.setFieldsValue({
      id: id
    }); //seteamos el
    setisModalSolAprobadorVisible(true);
  };
  const btnEditarDocumento = (data) => {
    history.push({
      pathname: '/vertical/editdocumentos',
      state: { id: data.id, idestado: data.estado }
    });
  };
  //#region metodo de crear directorio
  const onSubmitSolAprobadorOk = useCallback(async (values) => {
    const res: any = await gestionDocumentosProvider.AsignarAprobador({
      id: parseInt(values.getFieldValue('id')),
      idaprobador: parseInt(values.getFieldValue('idaprobador'))
    });
    if (res.succeeded) message.success(res.message);
    else message.warning(res.message);
    formModalSolAprobador.resetFields();
    setisModalSolAprobadorVisible(false);
  }, []);

  const IsModalSolAprobadorCancel = useCallback(() => {
    formModalSolAprobador.resetFields();
    setisModalSolAprobadorVisible(false);
  }, [formModalSolAprobador]);

  const obtenerListaValor = async () => {
    const resAprobadores: any = await gestionDocumentosProvider.ObtenerAprobadores();
    if (resAprobadores.succeeded) {
      setListAprobadores(resAprobadores.data);
    }
  };

  const getInit = async () => {
    const estado = await generalesProvider.ObtenerListaValorPorSkeyCab({
      skeycab: 'SKEYESTADOGESTIONDOCUMENTO'
    });
    setListEstado(estado);
    formFile.setFieldsValue({ estado: 1 }); //seteamos el
  };

  useEffect(() => {
    getInit();
  }, []);

  const listarArchivos = async () => {
    const paginacion = {
      IdEstado: filtro.IdEstado,
      Cip: filtro.Cip,
      pagenum: current,
      pagesize: pageSize
    };
    const res: any = await gestionDocumentosProvider.ListarArchivoPaginado(paginacion);
    if (res.data) setData(res);
  };

  useEffect(() => {
    listarArchivos();
  }, [filtro]);

  useEffect(() => {
    listarArchivos();
  }, [current]);

  const filtrar = async (val) => {
    //setcargando(true);
    const requestFiltro = {
      IdEstado: val.estado,
      Cip: val.cip === undefined ? '' : val.cip
    };
    setfiltro(requestFiltro);
    // const res = await gestionDocumentosProvider.ListarArchivoPaginado(requestFiltro);
    // if (res.data) setData(res);
  };

  return (
    <>
      <Card title={'Bandeja de Documentos'}>
        <div className='row'>
          <div className='col-md-12'>
            <Form
              {...formItemLayout}
              name='register'
              onFinish={filtrar}
              form={formFile}
              scrollToFirstError
            >
              <Row>
                <Col span={6}>
                  <Form.Item name='estado' label='Estado'>
                    <Select>
                      {listEstado.map((p, index) => {
                        return (
                          <Option key={index} value={p.idvalor}>
                            {p.descripcionvalor}
                          </Option>
                        );
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name='cip' label='CIP'>
                    <Input />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item>
                    <Button type='primary' icon={<SearchOutlined />} htmlType='submit'>
                      Buscar
                    </Button>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
        <div className='row'>
          <div className='col-md-12'>
            <Table
              locale={{ emptyText: 'No existen registros' }}
              pagination={false}
              columns={columns}
              dataSource={data.data}
              bordered
            />
            <Row justify={'center'}>
              <Col>
                <PaginacionPersonalizada
                  total={data.totalRecords}
                  current={current}
                  onChange={setCurrent}
                />
              </Col>
            </Row>
          </div>
        </div>
      </Card>
      <Modal
        title='Solicitar Aprobador'
        visible={isModalSolAprobadorVisible}
        onOk={formModalSolAprobador.submit}
        onCancel={IsModalSolAprobadorCancel}
        okText='Guardar'
        cancelText='Cancelar'
      >
        <div className='row'>
          <div className='col-md-12'>
            <Form
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
              form={formModalSolAprobador}
              onFinish={() => onSubmitSolAprobadorOk(formModalSolAprobador)}
              autoComplete='off'
            >
              <Form.Item
                name='idaprobador'
                label='Solicitar aprob. de'
                rules={[{ required: true, message: 'Seleccione un Aprobador!' }]}
              >
                <Select>
                  {listAprobadores.map((p, index) => {
                    return (
                      <Option key={index} value={p.usuarioId}>
                        {p.nombreCompleto}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
              <Form.Item label='id' name='id' noStyle>
                <Input type='hidden' />
              </Form.Item>
            </Form>
          </div>
        </div>
      </Modal>
    </>
  );
};
export default GestionDocumentos;
